module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/4be4be5c1d421c70060c33b427276953.png";